import React from "react";
import "./PartnerReportedList.scss";
// import MUITable from "../MUI/MUITable";
// import Button from '@mui/material/Button';
// import { Icon } from '@iconify/react';
// import plusFill from '@iconify/icons-eva/plus-fill';
import $ from "jquery";
import { Link } from 'react-router-dom';
import MyContext from "../../MyContext";
import { AddButtonTheme1 } from "../../../res/styler/ButtonThemes/ButtonThemes";
import {FcApproval, FcFullTrash} from 'react-icons/fc';
import { FaInfoCircle } from "react-icons/fa";

class PartnerReportedList extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      reported_partners : [],
      search_input : "",
      partner_comments : [],
      reject_reason : "",
      deleted_reason : "",
      partner_id : "",
    }
    this.partner_reported_list_page_Ref = React.createRef();
    this.delete_reason_container_ref = React.createRef();
    this.form_change = this.form_change.bind(this);
    this.delete_reported_comment = this.delete_reported_comment.bind(this);
    this.ignore_reported_comment = this.ignore_reported_comment.bind(this);
    this.delete_reported_notice = this.delete_reported_notice.bind(this);
    this.delete_form_submit = this.delete_form_submit.bind(this);
    this.ignore_reported_notice = this.ignore_reported_notice.bind(this);
  }

  componentDidMount(){
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url : process.env.REACT_APP_API+"/api/pendingPartnerReportedContents",
      data : this.context.bind_session({}),
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
     if(return_data.status == "success"){
      obj_this.setState({
        reported_partners : return_data.partners,
        partner_comments : return_data.comments
      },() => {
        obj_this.context.loading(0);
        obj_this.partner_reported_list_page_Ref.current.style.visibility = "visible";
        obj_this.partner_reported_list_page_Ref.current.style.opacity = 1;
      });
     }else{
       obj_this.context.loading(0);
       alert("Something Went Wrong. Please Try Again");
     }
    }).fail(function(){
      alert("Network error");
    });
  }

  form_change(e) {
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  delete_reported_notice(id, reported_reason){
    if(!window.confirm("Are your sure")){
      return;
    }
    this.delete_reason_container_ref.current.style.display = "block";
    this.setState({
      partner_id : id,
      selected_reported_reason : reported_reason
    })
  }

  delete_form_submit(e){
    e.preventDefault();
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url : process.env.REACT_APP_API+"/api/deleteReportedPartner",
      data : this.context.bind_session({
        partner_id : this.state.partner_id,
        deleted_reason : this.state.deleted_reason,
        selected_reported_reason : this.state.selected_reported_reason}),
      type : "POST"
    }).done(function(return_data){
      if(return_data.status == "success"){
        obj_this.context.loading(0);
        $.alert("Partner service deleted")
        obj_this.setState({
          reported_partners : obj_this.state.reported_partners.filter((item) => item.id != obj_this.state.partner_id),
          partner_comments : return_data.reported_comments,
          deleted_reason : "",
          selected_reported_reason : "",
          partner_id : ""
        });
        obj_this.delete_reason_container_ref.current.style.display = "none";
      }else{
        alert("Something Went Wrong. Please Try Again.");
      }
     }).fail(function(){
       alert("Network error");
     });
  }

  ignore_reported_notice(id){
    if(!window.confirm("Are your sure")){
      return;
    }
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url : process.env.REACT_APP_API+"/api/ignoreReportedPartner",
      data : this.context.bind_session({partner_id : id}),
      type : "POST"
    }).done(function(return_data){
      if(return_data.status == "success"){
        obj_this.context.loading(0);
        $.alert("Partner service removed from reported list.")
       obj_this.setState({
        reported_partners : obj_this.state.reported_partners.filter((item) => item.id != id),
       });
      }else{
        alert("Something Went Wrong. Please Try Again.");
      }
      obj_this.context.loading(0);
     }).fail(function(){
       alert("Network error");
     });
  }
 
  delete_reported_comment(comment_id){
    if (!window.confirm("Delete this comment")) {
      return;
    }
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url: process.env.REACT_APP_API + "/api/deleteReportedPartnerComment",
      data: this.context.bind_session({ comment_id: comment_id }),
      type: "POST"
    }).done(function (return_data) {
      if (return_data.status == "success") {
        obj_this.context.loading(0);
        obj_this.setState({
          partner_comments : obj_this.state.partner_comments.filter((item) => item.id != comment_id),
        });
        alert("Partner comment deleted");
        // obj_this.props.history.replace('/Dashboard/DeathNotices/Approvals');
      } else {
        alert("Something Went Wrong. Please Try Again.");
      }
    }).fail(function (return_data) {
      alert("Network error!!");
    });
  }

  ignore_reported_comment(comment_id, tribute_type){
    if(!window.confirm("Are your sure")){
      return;
    }
    var obj_this = this;
    this.context.loading(1);
    $.ajax({
      url: process.env.REACT_APP_API + "/api/ignoreReportedPartnerComment",
      data: this.context.bind_session({ comment_id: comment_id }),
      type: "POST"
    }).done(function (return_data) {
      if (return_data.status == "success") {
        obj_this.context.loading(0);
        obj_this.setState({
          partner_comments : obj_this.state.partner_comments.filter((item) => item.id != comment_id),
        });
        // obj_this.props.history.replace('/Dashboard/DeathNotices/Approvals');
      } else {
        alert("Something Went Wrong. Please Try Again");
      }
    }).fail(function (return_data) {
      alert("Network error!!");
    });
  }

  render(){
    return(
      <div className="partner_reported_list_page_container page_container" ref={this.partner_reported_list_page_Ref}>
        <div className="page_header">
          <div style={{display:this.context.session.user_type == "admin"?"block":"none"}} className="page_title">Reported Contents </div>
          <div style={{display:this.context.session.user_type == "partner"?"block":"none"}} className="page_title">Reported Testimonials </div>
          <div className="new_partner_button_container">
            {/* <Link to="/Dashboard/InMemoryNotices/New">
              <AddButtonTheme1 label="Publish Partner"/>
            </Link> */}
          </div>
        </div>
        <div style={{display:this.context.session.user_type == "admin"?"block":"none"}}>
          <div className="table_title">Partners</div>
          <div className="custom_table_theme1">
            <div className="table_row header">
            <div className="table_cell sl_no">Sl No.</div>
            <div className="table_cell fullname">Business Name</div>
            <div className="table_cell fullname">Partner Name</div>
            <div className="table_cell notice_type">Address</div>
            <div className="table_cell datetime">City</div>
            <div className="table_cell datetime">State</div>
            <div className="table_cell datetime">Reported On</div>
            <div className="table_cell">Reported By</div>
            <div className="table_cell">Action</div>
            </div>
            {this.state.reported_partners && this.state.reported_partners.map((item,idx) => (
              <div className="table_row body"
                key={idx} 
                >                
                <div className="table_cell sl_no">{idx+1}</div>
                <div className="table_cell">{item.business_name}</div>
                <div className="table_cell">{item.entered_by}</div>
                <div className="table_cell notice_type">{item.business_address}</div>
                <div className="table_cell">{item.city}</div>
                <div className="table_cell">{item.flag} {item.state}</div>
                <div className="table_cell">{new Date(item.reported_at).toLocaleDateString('en-GB')}</div>
                <div className="table_cell">{item.reported_by}</div>
                <div className="table_cell">
                <div className="action">
                  <div className="tooltip approve">
                      <span className="tooltipText approve">Ignore</span>
                      <FcApproval className="approve_button" onClick={() => this.ignore_reported_notice(item.id)}/>
                    </div>
                    <div className="tooltip delete">
                      <span className="tooltipText delete">Delete</span>
                      <FcFullTrash className="delete_button" onClick={() => this.delete_reported_notice(item.id, item.reason)}/>
                    </div>
                    <div className="tooltip reason" onClick={() => this.setState({reported_reason : item.reason})}>
                      <span className="tooltipText reason">Reason</span>
                      <FaInfoCircle className="delete_button"/>
                    </div>
                 </div>
                </div>
              </div>
            ))}
            <div className="table_row no_results" style={{display:this.state.reported_partners.length?"none":"block"}}>No results.</div>
          </div>
        </div>
        {/* <div style={{display:this.state.partner_comments.length?"block":"none"}}> */}
          <div style={{display:this.context.session.user_type == "admin"?"block":"none"}} className="table_title">Testimonials</div>
          <div className="custom_table_theme1">
            <div className="table_row header">
            <div className="table_cell sl_no">Sl No.</div>
              <div className="table_cell fullname">Reported By</div>
              <div className="table_cell fullname">Business Name</div>
              <div className="table_cell">Testimonials</div>
              <div className="table_cell datetime">Reported On</div>
              <div className="table_cell">Action</div>
              
            </div>
            {this.state.partner_comments && this.state.partner_comments.map((item,idx) => (
              <div className="table_row body"
                key={idx}
                >
                <div className="table_cell sl_no">{idx+1}</div>
                <div className="table_cell">{item.fullname}</div>
                <div className="table_cell">{item.business_name}</div>
                <div className="table_cell">
                  {item.comment}
                </div>
                <div className="table_cell">{new Date(item.reported_at).toLocaleDateString('en-GB')}</div>
                <div className="table_cell">
                  <div className="action">
                    <div className="tooltip approve">
                      <span className="tooltipText approve">Ignore</span>
                      <FcApproval className="approve_button" onClick={() => this.ignore_reported_comment(item.id)}/>
                    </div>
                    <div className="tooltip delete">
                      <span className="tooltipText delete">Delete</span>
                      <FcFullTrash className="delete_button" onClick={() => this.delete_reported_comment(item.id )}/>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="table_row no_results" style={{display:this.state.partner_comments.length?"none":"block"}}>No results.</div>
          {/* </div> */}
        </div>
        <div className="view_message_ghost" style={{display:this.state.reported_reason?"block":"none"}}>
          <div className="view_message" 
          >
          <div className="add_message_title">Reported Reason</div>
            <div className="details_grid">
              <div className="label"></div>
              <div className="value">{this.state.reported_reason}</div>
            </div>
            <div className="close_message_form"
              onClick={() => {
                this.setState({
                  reported_reason  : ""
                })
              }}
            >
              <div>x</div>
            </div>
          </div>
        </div>
        <div className="delete_reason_container" ref={this.delete_reason_container_ref}>
          <form className="delete_reason_form" onSubmit={this.delete_form_submit} method="post">
            <div className="delete_reason_title">Delete reason</div>
            <div className="delete_reason_form_body">
              <textarea name="deleted_reason"
                rows={4}
                value={this.state.deleted_reason}
                onChange={this.form_change}
                required
                placeholder="Type here.."
              />
              <button className="delete_form_submit_button">Submit</button>
            </div>
            <div className="delete_form_close_button" onClick={() => { 
              this.delete_reason_container_ref.current.style.display = "none"; 
              this.setState({ 
                deleted_reason : "",
                selected_reported_reason : "",
                memorial_id : "" }) }}>x</div>
          </form>
        </div>
      </div>
    )
  }
}

export default PartnerReportedList;
PartnerReportedList.contextType = MyContext;